

const PurchaseApmc = () => {

  return (
    <>
    <div className="page-wrapper">
        <div className="w-100 d-flex flex-column justify-content-end px-5 ">
            <h2 className="py-3">Proposal for permission for buying land </h2>
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>
                    <div id='head' className='d-flex w-100 rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                    </div>
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                        <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                            <p className='p-2'>
                               બજાર સમિતિએ સરકારી જમીન મેળવવા કરેલ કામગીરીની વિગત (ટૂંકી નોંધ સહિત)Committee to acquire government land, including a brief note.
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                             <input
                                className="border w-75 p-2 rounded"
                                name="committeeName"
                                placeholder="Write a note"
                            />
                            <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
    
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            સરકારી જમીન ઉપલબ્ધ નથી તે મુજબનું રેવન્યુ ઓથોરિટીનું પ્રમાણપત્ર (Certificate from the Revenue Authority stating that government land is not available.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>03.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિની સાધારણ સભા/ખાસ સાધારણ સભાના ઠરાવથી આ બાબત નિર્ણય કરેલી હોવી જોઈએ. આ એજન્ડા/ઠરાવની પ્રમાણિત નકલ. આ અંગે કોઇનો વાંધો હોય તો તેની નકલ (બેઠકમાં રજૂ કરેલો ન હોય તો પણ) The matter must be resolved in a general/special meeting of the Market Committee. Attach a certified copy of the agenda/resolution. If any objection exists, a copy should also be included, even if it was not presented in the meeting.
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>04.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિ દ્વારા ગ્રામ્ય વિસ્તારની જમીન ખરીદવામાં આવે તો નમૂના ૬, ૮-અ અને ૭/૧૨ના તાજેતરના ઉતારા અને શહેરી વિસ્તાર માટે સીટી સર્વે કચેરીમાંથી પ્રોપર્ટી કાર્ડની નકલ (If rural land is purchased, provide recent copies of Forms 6, 8A, and 7/12. For urban land, include the property card issued by the City Survey Office.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>05.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            સરકાર માન્ય વેલ્યુઅર પાસેથી જમીનના વેલ્યુએશન રિપોર્ટ, ટાઇટલ ક્લીયરન્સ રિપોર્ટ અને પ્લાન લે-આઉટની વિગતો તથા સર્ચ રિપોર્ટ (Land valuation report, title clearance report, plan layout details, and search report from a government-approved valuer.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>06.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           સરકારશ્રીની જોગવાઈ મુજબ તે જમીનની સરકાર માન્ય જંત્રીની વિગત (Details of the government-approved Jantri rate for the land as per government norms.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>07.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           જમીન મેળવવા અંગે વર્તમાનપત્રમાં આપેલ જાહેરાતની વિગત તથા અપનાવેલ ટેન્ડર પ્રક્રિયા અંગેની તમામ વિગત તેમજ ટેન્ડર પ્રક્રિયા દરમ્યાન જેના ભાવ નીચા આવેલ હોય તેની સાથે કરેલ નેગોશિએશનની તમામ કાર્યવાહી ની વિગત (Details of newspaper advertisements given for acquiring the land, full details of the tender process followed, and negotiations carried out with the lowest bidder.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>08.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            જમીન ખરીદી અંગે ઉપલબ્ધ ભંડોળ અને આયોજનની વિગત ( Details of available funds and budget planning for land purchase.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>09.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           જમીનની બજાર સમિતિને જરૂરિયાત છે, તેના કારણો તથા બજાર સમિતિને થનાર લાભ તથા આ જમીન પર ઉભી થનાર સુવિધાઓની વિગતો (Reasons for the Market Committee's need for the land, expected benefits, and details of facilities to be developed on the land.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>10.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-start'>
                        <p className='p-2'>
                            બજાર સમિતિ પાસે હાલ ઉપલબ્ધ તમામ જમીનની વિગતો. <br />
                            (Details of all land currently owned by the Market Committee.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>11.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           જે જમીન બજાર સમિતિ ખરીદી રહી છે તે જમીન હાલના માલિકે તે પહેલા કોની પાસેથી ખરીદી હતી? કેટલી કિંમતમાં, કેટલા સમય પહેલા ખરીદાઈ હતી? તેની વિગતો. (ઈન્ડેક્ષ) (Details of the land's previous ownership before the current seller: from whom it was purchased, at what price, and when. Include the index.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>12.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            સૂચિત જમીન અંગે કોઈ કોર્ટ કેસ (રેવન્યુ / જ્યુડિશિયલ) કેસ ચાલુ ન હોય તે અંગેનું બજાર સમિતિનું પ્રમાણપત્ર (Certificate from the Market Committee stating that there is no ongoing court case (revenue/judicial) related to the proposed land.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>13.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            જમીન/મિલકત વેચનાર વ્યક્તિ બજાર સમિતિના નિયામક મંડળના સભ્ય કે સંબંધી છે? બજાર સમિતિ સાથે પ્રત્યક્ષ કે પરોક્ષ રીતે સંકળાયેલ છે કે કેમ? તેની સ્પષ્ટ વિગતો (Clear details on whether the land/property seller is a member or relative of the Market Committee’s board, or has any direct or indirect association with the Market Committee.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>14.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિના છેલ્લાં ત્રણ વર્ષના આવક-જાવકના પત્રક, મહેકમ ખર્ચના પત્રક, તથા પાકા સરવૈયા (ઓડીટેડ) કાયમી ભંડોળના પત્રક રજૂ કરવા. ( Submit income-expenditure statements, administrative expense reports, and audited permanent fund statements for the last three years.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>15.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિના છેવટની તારીખના કાચા સરવૈયાની નકલ તથા છેલ્લો ઓડિટ મેમો. (Copy of the latest provisional balance sheet and the most recent audit memo of the Market Committee.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>16.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            જમીન ખરીદ્યા બાદ બજાર સમિતિના વહીવટી ખર્ચ અને મહેકમ ખર્ચ યોગ્ય ધારાધોરણ – નિયમ મુજબ જળવાઈ રહેશે તેની બાંહેધરી. (Undertaking that the Market Committee’s administrative and operational expenses will be maintained as per applicable rules and standards after the land purchase.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>17.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિ નફો કરે છે તેવું બજાર સમિતિનું પ્રમાણપત્ર (Certificate from the Market Committee stating that it is operating profitably.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>18.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            ઉપરોક્ત તમામ બાબતો સાંકળી લેતો સહકારી અધિકારી (બજાર)નો સ્થળ તપાસ અહેવાલ. (રોજકામ ફોટોગ્રાફ સહ) (Site inspection report by the Co-operative Officer (Market) covering all the above matters, along with work photographs.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>19.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (અ/બ/ક/S) (Certificate of income-based classification of the Market Committee (A/B/C/S).)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 

                </div>
            </div>
        </div>
        <div className="d-flex align-items-center">
            <div className="m-5 w-75 d-flex fle flex-row align-items-start gap-3 border bg-white border-secondary rounded mb-5 p-3">
            
            {/* Left Side - Checkbox */}
                <div className="pt-2">
            <input
                className="form-check-input"
                type="checkbox"
                name="agreeTerms"
                id="agreeTerms"
                style={{ transform: 'scale(1.5)' }}
            />
            </div>

            {/* Right Side - Form + Button */}
            <div className="flex-grow-1"> 
            <div className="p-2 rounded">
                <p>
                ઉપર મુજબના તમામ સાથેલ દસ્તાવેજો, પ્રમાણપત્રો તથા માહિતીની ચકાસણી / ખરાાઈ કરેલ <br />
                All the above-mentioned supporting documents, certificates, and information have been verified and cross-checked.
                </p>

                {/* ✅ Button inside the right side */}
            </div>
            </div>
            </div>
        <div className="d-flex h-25 px-5">
            <button className="btn btn-info">Next</button>
        </div>
        </div>
        </div>
    </>
  )
}

export default PurchaseApmc